import React from 'react';
import styles from './ProgressBarProject.module.scss';
import {Money as MoneyI} from "../../../../api-client";
import {Money} from "../../../common";

interface Props {
    investedSum: MoneyI,
    total: MoneyI
}
export const ProgressBarProject = ({investedSum, total}: Props) => {
  const percentage = Math.min((investedSum.amount / (total.amount + investedSum.amount)) * 100, 100);

  return (
    <div className={styles.progressContainer}>
      <span className={styles.label}>Собрано/доступно</span>
      <div className={styles.progressBar}>
        <div
          className={styles.progressFill}
          style={{width: `${percentage}%`}}
        ></div>
      </div>
      <div className={styles.amounts}>
        <span className={styles.collected}><Money money={investedSum}/></span>
        <span className={styles.total}><Money money={total}/></span>
      </div>
    </div>
  );
};
